(function () {
  var root = document.querySelector('[data-ilmas-pdp]');
  if (!root) return;
  var src = root.querySelector('[data-ilmas-src]');
  var main = root.querySelector('[data-ilmas-main-img]');
  var thumbsWrap = root.querySelector('[data-pool-thumbs]');
  if (!src || !main) return;

  var BOILER_RE = /medidas son aproximadas|ILMAS te asesora|Te ayudamos a comparar|proyecto sujeto a estudio|acabado debe confirmarse|color también forma parte/i;

  var seen = {};
  var imgs = [];
  src.querySelectorAll('img').forEach(function (img) {
    var btn = img.closest('[data-image-src]');
    var s = (btn && btn.getAttribute('data-image-src')) || img.getAttribute('src') || '';
    if (!s || seen[s]) return;
    if (/icon|logo|badge|pixel/i.test(s)) return;
    seen[s] = true;
    imgs.push({ src: s, alt: img.getAttribute('alt') || '' });
  });

  src.querySelectorAll('.ipp-panel, .ipp-actions, .ipp-specs, .ipp-related, .ipp-finishes, form').forEach(function (el) {
    el.remove();
  });
  src.querySelectorAll('p').forEach(function (p) {
    if (BOILER_RE.test(p.textContent)) p.remove();
  });

  function show(item, btn) {
    main.src = item.src;
    main.removeAttribute('srcset');
    main.alt = item.alt || main.alt;
    if (thumbsWrap) {
      thumbsWrap.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });
    }
  }

  if (!imgs.length) return;
  show(imgs[0], null);
  if (thumbsWrap && imgs.length > 1) {
    thumbsWrap.hidden = false;
    imgs.slice(0, 8).forEach(function (item, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ilmas-pdp__thumb' + (idx === 0 ? ' is-active' : '');
      btn.setAttribute('aria-pressed', idx === 0 ? 'true' : 'false');
      btn.setAttribute('aria-label', 'Ver imagen ' + (idx + 1));
      var im = document.createElement('img');
      im.src = item.src;
      im.alt = '';
      im.width = 80;
      im.height = 80;
      im.loading = 'lazy';
      btn.appendChild(im);
      btn.addEventListener('click', function () { show(item, btn); });
      thumbsWrap.appendChild(btn);
    });
  }
})();
